import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { PRINT_ASSIGNED_TO_ID } from '../../../constants';

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(1, 0),
    fontSize: theme.typography.pxToRem(12)
  }
}));

const TrackingNumber = ({ printingRequest }) => {
  const classes = useStyles();

  const courier = printingRequest ? printingRequest.courier : null;

  const trackingNumber = useMemo(() => {
    if (!printingRequest) {
      return null;
    }

    if (printingRequest.tracking_number) {
      return (
        <>
          {courier && (
            <>
              <a href={courier.link} rel="noopener noreferrer" target="_blank">
                {printingRequest.tracking_number}
              </a>
            </>
          )}
          {!courier && printingRequest.tracking_number}
        </>
      );
    }

    if (printingRequest.assigned_to === PRINT_ASSIGNED_TO_ID.orthoselect) {
      return 'Pending';
    }

    return 'N/A';
  }, [printingRequest, courier]);

  if (!printingRequest) {
    return null;
  }

  return (
    <div className={classes.container}>
      <strong>Tracking #:</strong> {trackingNumber}
    </div>
  );
};

TrackingNumber.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  printingRequest: PropTypes.object
};

TrackingNumber.defaultProps = {
  printingRequest: null
};

export default TrackingNumber;
